export default function About() {
    return (
        <div className="w-full bg-white">
            <div className="max-w-5xl mx-auto px-6 py-14">

                {/* PAGE TITLE */}
                <h1 className="text-3xl font-extrabold text-gray-900 mb-6">
                    About BlogySports
                </h1>

                {/* INTRO */}
                <p className="text-gray-700 leading-relaxed mb-6">
                    <strong>BlogySports</strong> is an independent sports news and content
                    platform created for fans who want fast, clear, and reliable sports updates
                    from around the world.
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We cover all major sports including cricket, football, tennis, basketball,
                    hockey, and more. Our goal is to deliver sports news in simple English that
                    everyone can understand and enjoy.
                </p>

                {/* WHAT WE DO */}
                <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">
                    What We Do
                </h2>

                <p className="text-gray-700 leading-relaxed mb-4">
                    At BlogySports, we focus on:
                </p>

                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                    <li>Latest sports news and breaking updates</li>
                    <li>Match highlights and key moments</li>
                    <li>Player performances and team analysis</li>
                    <li>Tournament previews and results</li>
                    <li>Trending sports stories worldwide</li>
                </ul>

                <p className="text-gray-700 leading-relaxed mb-6">
                    All articles are written in easy-to-read language so sports fans from
                    India, the US, the UK, and across the globe can follow the action without
                    confusion.
                </p>

                {/* MISSION */}
                <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">
                    Our Mission
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Our mission is to make sports news simple, fast, and trustworthy.
                    We believe sports content should be accurate, engaging, and easy to follow
                    for every fan.
                </p>

                {/* WHY TRUST */}
                <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">
                    Why Trust BlogySports
                </h2>

                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                    <li>Original and human-written sports content</li>
                    <li>No misleading or click-bait headlines</li>
                    <li>Focus on verified and trending sports news</li>
                    <li>Clear, honest, and fan-friendly reporting</li>
                </ul>

                {/* WHO WE ARE */}
                <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">
                    Who We Are
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports is run by sports enthusiasts who follow games closely and enjoy
                    sharing updates, insights, and analysis. We are not tied to any team,
                    league, or organization, which helps us stay unbiased and independent.
                </p>

                {/* AUDIENCE */}
                <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4">
                    Our Audience
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    BlogySports is made for all sports lovers — casual fans, serious followers,
                    students, and professionals. You don’t need expert knowledge to enjoy
                    our content.
                </p>

                {/* CLOSING */}
                <p className="text-gray-700 leading-relaxed mt-10">
                    Thank you for visiting <strong>BlogySports</strong>.
                    Stay connected with us for the latest sports news, match updates,
                    and trending stories from around the world.
                </p>

            </div>
        </div>
    );
}
